<div class="auth-banner" *ngIf="(isLogged$ | async) === false">
  <img
    src="assets/icons/shopping-cart-plus-banner.svg"
    alt="agregar al carrito"
  />
  <p>
    Para agregar productos a tu carrito,
    <span (click)="openMobileMenu()">iniciar sesión</span>. ¿Aún no tienes una cuenta?
    <a routerLink="/auth/sign-up">Regístrate.</a>
  </p>
</div>
